<template>
  <egg-label-list
    title="patients.patientExp"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconGreen', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconGreenLeft', imgFormat: 'svg' }"
    :eggBackgroundObj="{ componentName: 'shared', imgName: 'greenegg', imgFormat: 'svg' }"
    labelColor="#4E4E4E"
    :eggIconLabelList="patientsStore.eggDescList"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { usePatientsStore } from "@/stores/patients";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const patientsStore = usePatientsStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>